module.exports = __webpack_public_path__ + "static/media/07-print-ad.f8f74d2d.png";